import React, { useState, useEffect } from 'react';
import { FaTimes, FaPercentage, FaCoins, FaCheckCircle, FaHistory, FaClock } from 'react-icons/fa';
import './ChegirmaModal.css';
import CONFIG from '../config';
import { formatSumma } from '../utils/format';
import { getRanks, defaultRanks } from "../services/rankService";

const ChegirmaModal = ({ onClose }) => {
    const [discounts, setDiscounts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        const fetchDiscounts = async () => {
            try {
                const token = localStorage.getItem('loyiha_token');
                const response = await fetch(`${CONFIG.API_BASE_URL}/get_user_discounts.php`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                const data = await response.json();
                if (data.status === 'success') {
                    setDiscounts(data.data);
                }
            } catch (error) {
                console.error("Chegirmalarni yuklashda xatolik:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchDiscounts();
    }, []);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            onClose();
        }, 300);
    };

    const [tooltip, setTooltip] = useState({ visible: false, text: '', x: 0, y: 0 });

    const [rankTitles, setRankTitles] = useState(["Barcha uchun", ...defaultRanks]);

    useEffect(() => {
        getRanks().then(ranks => {
            setRankTitles(["Barcha uchun", ...ranks]);
        });
    }, []);

    const handleMouseEnter = (e, text) => {
        const rect = e.target.getBoundingClientRect();
        setTooltip({
            visible: true,
            text: text,
            x: rect.left + (rect.width / 2),
            y: rect.top - 10 // Position above
        });
    };

    const handleMouseLeave = () => {
        setTooltip({ ...tooltip, visible: false });
    };

    const getRankLabel = (level) => {
        const tooltipText = level === 0
            ? "Barcha foydalanuvchilar uchun"
            : `${rankTitles[level] || "Noma'lum"} darajasidagi foydalanuvchilar uchun`;

        return (
            <span
                className={`rank-badge level-${level}`}
                onMouseEnter={(e) => handleMouseEnter(e, tooltipText)}
                onMouseLeave={handleMouseLeave}
            >
                {level === 0 ? "Barcha uchun" : (rankTitles[level] || "Noma'lum")}
            </span>
        );
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'active':
                return <span className="status-badge active"><FaCheckCircle /> Faol</span>;
            case 'used':
                return <span className="status-badge used"><FaHistory /> Ishlatilgan</span>;
            case 'expired':
                return <span className="status-badge expired"><FaClock /> Muddati tugagan</span>;
            case 'full':
                return <span className="status-badge full"><FaTimes /> Chegirma to'lgan</span>;
            default:
                return status;
        }
    };

    return (
        <div className={`chegirma-modal-overlay ${isClosing ? 'fade-out' : 'fade-in'}`} onClick={handleClose}>
            <div
                className={`chegirma-modal-content ${isClosing ? 'scale-out' : 'scale-in'}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="chegirma-modal-header">
                    <h3>Chegirma</h3>
                    <button className="close-btn" onClick={handleClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="chegirma-modal-body">
                    {loading ? (
                        <div className="loading-spinner">Yuklanmoqda...</div>
                    ) : (
                        <div className="table-container">
                            <table className="chegirma-table">
                                <thead>
                                    <tr>
                                        <th>Nomi</th>
                                        <th>Kod</th>
                                        <th>Daraja</th>
                                        <th>Chegirma</th>
                                        <th>Amal qiladi</th>
                                        <th>Holati</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {discounts.map((item, index) => (
                                        <tr key={item.id} style={{ animationDelay: `${index * 0.1}s` }} className="table-row-anim">
                                            <td className="nomi-cell">{item.nomi}</td>
                                            <td className="code-cell"><code>{item.kod}</code></td>
                                            <td>{getRankLabel(item.daraja)}</td>
                                            <td className="value-cell">
                                                {item.chegirma_foizi > 0 ? (
                                                    <span className="discount-tag percent">
                                                        <FaPercentage /> {item.chegirma_foizi}%
                                                    </span>
                                                ) : (
                                                    <span className="discount-tag coin">
                                                        <FaCoins /> {formatSumma ? formatSumma(item.chegirma_summasi) : item.chegirma_summasi} tanga
                                                    </span>
                                                )}
                                            </td>
                                            <td>{item.amal_qilish_vaqti}</td>
                                            <td>{getStatusBadge(item.status)}</td>
                                        </tr>
                                    ))}
                                    {discounts.length === 0 && (
                                        <tr>
                                            <td colSpan="4" className="no-data">Hozircha chegirmalar mavjud emas</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
            {/* Floating Tooltip */}
            {tooltip.visible && (
                <div
                    className="floating-tooltip"
                    style={{
                        top: tooltip.y,
                        left: tooltip.x
                    }}
                >
                    {tooltip.text}
                </div>
            )}
        </div>
    );
};

export default ChegirmaModal;
